<template>
  <main role="main" class="container justify-content-md-center">
    <div class="row">
        <div v-if="errors && errors.length">
            <div v-bind:key="error" v-for="error of errors" class="alert alert-warning alert-dismissible fade show" role="alert">
                {{error}}
            </div>
        </div>
    </div>
    <div v-if="item">
        <div class="row justify-content-md-center">
            <h4>Confirm you would like to disable following job</h4>
        </div>
        <div class="row justify-content-md-center">
            <h3>{{item.name}}</h3>
        </div>
    </div>
    <div class="row">
        <div class="row" v-if="notices && notices.length">
            <div v-bind:key="notice" v-for="notice of notices" class="alert alert-success alert-dismissible fade show" role="alert">
                {{notice}}
            </div>
        </div>
    </div>
    <div class="row justify-content-md-center">
        <form>
            <b-button type="button" v-on:click="submit()" variant="primary">Yes, disable this job</b-button>
        </form>
    </div>
  </main>
</template>

<script>
import axios from 'axios';
import AppConfig from '../util/config';
export default {
    data() {
        return {
            scheduleId: null,
            errors: [],
            notices: [],
            item: null
        }
    },
    methods: {
        getItem(scheduleId) {
            axios.get(AppConfig.BACKEND_ENDPOINT + "/pub/schedule/" + scheduleId + "/basic").then(result => {
                if (result.data.data) {
                    this.item = result.data.data;
                } else if (result.data.error) {
                    this.errors.push("There was an error.");
                }
            }).catch(e => {
                if (e.response.status === 503) {
                  this.errors.push("Service is temporarily unavailable. Please try again later.");
                } else {
                  this.errors.push(e.response.data.error);
                }
            }) 
        },
        submit() {
            this.notices = [];
            this.errors = [];

            if (!this.item) {
                this.errors.push("Sorry, there's been an issue. Please try again later.");
                return;
            }

            axios.patch(AppConfig.BACKEND_ENDPOINT + "/pub/schedule/" + this.scheduleId + "/disable", {}).then(result => {
                if (result.data.data) {
                    this.notices.push("Job has been disabled.");
                } else if (result.data.error) {
                    this.errors.push("There was an error.");
                }
            }).catch(e => {
                if (e.response.status === 503) {
                  this.errors.push("Service is temporarily unavailable. Please try again later.");
                } else {
                  this.errors.push(e.response.data.error);
                }
            }) 
        }
    },
    mounted() {
        if (this.$route.params.id) {
            this.scheduleId = this.$route.params.id;
            this.getItem(this.scheduleId);
        } else {
            this.$router.replace({ name: "404" });
        }
    }
}
</script>
